import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4938b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " 分享资讯 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon share-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-weixin" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信好友", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon share-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-pengyouquan" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信朋友圈", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon share-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-lianjie" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制链接", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "feedback-btn-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon feedback-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-jubao" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "举报", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon feedback-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-yijianfankui" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "意见反馈", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

import {computed} from 'vue';
import {Popup} from 'vant';
import {shareUrlToWechat, copyStr, showFeedback} from '@/bridge';
import {useShare, useReport} from '@/service/detail';
import {resizeImg} from '@/utils/handleImg';
import {haboClickReport} from '@/plugins/haboConfig';
import {usePopReturn} from '@/hooks/usePopReturn';
import useUa, {XApp} from '@/hooks/useUa';
import {useHaboInfo} from '@/hooks/useHaboInfo';

enum AppName {
  isGaotuApp = 'gaotu',
  isGongkaoApp = 'gongkao',
  isTutuApp = 'tutu',
  isJingpinApp = 'jingpin',
  isXinliApp = 'xinli',
  isKetangApp = 'ketang',
}
enum AppLogoUrl {
  gaotu = 'https://i.gsxcdn.com/1828068219_nk7yp3od.png?x-oss-process=image/resize,w_200/quality,Q_90',
  gongkao = 'https://i.gsxcdn.com/1749492627_8rkrmxhs.jpeg?x-oss-process=image/resize,w_200/quality,Q_90',
  tutu = 'https://i.gsxcdn.com/1826330136_pppvgnao.png?x-oss-process=image/resize,w_200/quality,Q_90',
  jingpin = 'https://i.gsxcdn.com/1841349117_66ivlf8y.png?x-oss-process=image/resize,w_200/quality,Q_90',
  xinli = 'https://i.gsxcdn.com/1988183528_npf4nmjf.png?x-oss-process=image/resize,w_200/quality,Q_90',
  ketang = 'https://i.gsxcdn.com/2300160331_ll7v0tae.png?x-oss-process=image/resize,w_200/quality,Q_90',
}

const __default__ = {
  name: 'MorePopup',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    informationId: null,
    detailInfo: null,
    isShowPopup: { type: Boolean },
    isShowFeedback: { type: Boolean, default: true },
    hidePopup: null
  },
  setup(__props: any) {

const props = __props as { informationId: number, detailInfo: InfoItem, isShowPopup: boolean, isShowFeedback: boolean, hidePopup:() => void }



const isShowPopupDraft = computed({
  get() {
    return props.isShowPopup;
  },
  set(val: boolean) {
    props.hidePopup();
  },
});

const resizeUrl = computed(() =>
  resizeImg(props.detailInfo?.thumbnailUrl, 128));

const {cmsCode, contentCode} = useHaboInfo();
const {isXApp} = useUa();
const app
  = AppName[
    (Object.keys(isXApp) as (keyof XApp)[]).find(
      (item: keyof XApp) => isXApp[item],
    )!
  ];
const queryStr = `cmsCode=${cmsCode}&contentCode=${contentCode}&channel=browser&app=${app}&previewSource=2`;
const defaultCardImg = AppLogoUrl[app];
// 分享微信好友
const handleShareFriends = () => {
  useShare(props.informationId);

  shareUrlToWechat({
    type: 0,
    title: props.detailInfo?.title,
    content: props.detailInfo?.description || '',
    img: resizeUrl.value || defaultCardImg,
    url: `${window.location.origin}${window.location.pathname}?${queryStr}`,
  });
  haboClickReport('INFO_ARTICLE_SHARE_CHANNEL', {
    share_channel: 2,
    news_id: props.informationId,
  });

  props.hidePopup();
};
// 分享朋友圈
const handleShareMoment = () => {
  useShare(props.informationId);

  shareUrlToWechat({
    type: 1,
    title: props.detailInfo?.title,
    content: props.detailInfo?.description || '',
    img: resizeUrl.value || defaultCardImg,
    url: `${window.location.origin}${window.location.pathname}?${queryStr}`,
  });
  haboClickReport('INFO_ARTICLE_SHARE_CHANNEL', {
    share_channel: 3,
    news_id: props.informationId,
  });

  props.hidePopup();
};
// 复制链接
const handleCopyLink = () => {
  copyStr(`${window.location.origin}${window.location.pathname}?${queryStr}`);
  haboClickReport('INFO_ARTICLE_SHARE_CHANNEL', {
    share_channel: 4,
    news_id: props.informationId,
  });
  props.hidePopup();
};
// 举报
const handleReport = () => {
  useReport(props.informationId);
  haboClickReport('INFO_ARTICLE_ACC_CLICK', {
    news_id: props.informationId,
  });
  props.hidePopup();
};
// 反馈
const handleFeedback = () => {
  showFeedback();
  props.hidePopup();
};

const {handleClose, handleOpen} = usePopReturn(
  isShowPopupDraft,
  props.hidePopup,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: _unref(isShowPopupDraft),
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isShowPopupDraft) ? (isShowPopupDraft).value = $event : null)),
    round: "",
    position: "bottom",
    onOpen: _unref(handleOpen),
    onClose: _unref(handleClose)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", { class: "share-btn-box" }, [
          _createElementVNode("div", {
            class: "share-btn",
            onClick: handleShareFriends
          }, _hoisted_5),
          _createElementVNode("div", {
            class: "share-btn",
            onClick: handleShareMoment
          }, _hoisted_8),
          _createElementVNode("div", {
            class: "share-btn",
            onClick: handleCopyLink
          }, _hoisted_11)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "feedback-btn",
            onClick: handleReport
          }, _hoisted_15),
          _createElementVNode("div", {
            class: "feedback-btn",
            onClick: handleFeedback
          }, _hoisted_18)
        ], 512), [
          [_vShow, __props.isShowFeedback]
        ]),
        _createElementVNode("footer", {
          class: "cancel-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.hidePopup && __props.hidePopup(...args)))
        }, " 取消 ")
      ])
    ]),
    _: 1
  }, 8, ["show", "onOpen", "onClose"]))
}
}

})